import { render } from "./SelectTree.vue?vue&type=template&id=6db7dc20&ts=true"
import script from "./SelectTree.vue?vue&type=script&lang=ts"
export * from "./SelectTree.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/yuhuiliu/code/btkcode/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__